// mds-dojo — dijit/_editor/html — FAITHFUL port of references/dijit/_editor/html.js.
// HTML serialization utility functions used by the editor.
//
// ADAPTATIONS for this package:
//  - `dojo/sniff` → `../../dojo/has`; `dojo/_base/array` import dropped (only used by the
//    IE6-7 code path that is removed below).
//  - BROWSER-FORK COLLAPSE: in getNodeHtmlHelper the attribute-serialization had two
//    branches — the "IE8+ and all other browsers" branch (guarded by
//    has("dom-attributes-explicit")||has("dom-attributes-specified-flag")) and a legacy
//    IE6-7 outerHTML-regexp branch. Only the modern branch is kept; the IE6-7 else is
//    dropped. The `has("ie")===8` style-casing fixup inside it is also dropped (evergreen).
//  - has("dom-attributes-explicit")/has("dom-attributes-specified-flag")/has("ie") feature
//    tests are left in place: they resolve correctly through the mds has() module.
import lang from '../../dojo/_base/lang'; // lang.setObject
import has from '../../dojo/has';

// module:
//		dijit/_editor/html

var exports: any = {
	// summary:
	//		HTML serialization utility functions used by editor
};
lang.setObject("dijit._editor.html", exports);

var escape = exports.escapeXml = function(/*String*/ str: any, /*Boolean?*/ noSingleQuotes?: any){
	// summary:
	//		Adds escape sequences for special characters in XML: `&<>"'`.
	//		Optionally skips escapes for single quotes.
	str = str.replace(/&/gm, "&amp;").replace(/</gm, "&lt;").replace(/>/gm, "&gt;").replace(/"/gm, "&quot;");
	if(!noSingleQuotes){
		str = str.replace(/'/gm, "&#39;");
	}
	return str; // string
};

exports.getNodeHtml = function(/*DomNode*/ node: any){
	// summary:
	//		Return string representing HTML for node and it's children
	var output: any[] = [];
	exports.getNodeHtmlHelper(node, output);
	return output.join("");
};

exports.getNodeHtmlHelper = function(/*DomNode*/ node: any, /*String[]*/ output: any){
	// summary:
	//		Pushes array of strings into output[] which represent HTML for node and it's children
	switch(node.nodeType){
		case 1: // element node
			var lName = node.nodeName.toLowerCase();
			if(!lName || lName.charAt(0) == "/"){
				// IE does some strange things with malformed HTML input, like
				// treating a close tag </span> without an open tag <span>, as
				// a new tag with tagName of /span.  Corrupts output HTML, remove
				// them.  Other browsers don't prefix tags that way, so will
				// never show up.
				return "";
			}
			output.push('<', lName);

			// store the list of attributes and sort it to have the
			// attributes appear in the dictionary order
			var attrarray: any[] = [], attrhash: any = {};
			var attr;
			// IE8+ and all other browsers.
			var i = 0;
			while((attr = node.attributes[i++])){
				// ignore all attributes starting with _dj which are
				// internal temporary attributes used by the editor
				var n = attr.name;
				if(n.substr(0, 3) !== '_dj' &&
					(!has("dom-attributes-specified-flag") || attr.specified) && !(n in attrhash)){    // workaround repeated attributes bug in IE8 (LinkDialog test)
					var v = attr.value;
					if(n == 'src' || n == 'href'){
						if(node.getAttribute('_djrealurl')){
							v = node.getAttribute('_djrealurl');
						}
					}
					attrarray.push([n, v]);
					attrhash[n] = v;
				}
			}
			attrarray.sort(function(a: any, b: any){
				return a[0] < b[0] ? -1 : (a[0] == b[0] ? 0 : 1);
			});
			var j = 0;
			while((attr = attrarray[j++])){
				output.push(' ', attr[0], '="',
					(typeof attr[1] === "string" ? escape(attr[1], true) : attr[1]), '"');
			}
			switch(lName){
				case 'br':
				case 'hr':
				case 'img':
				case 'input':
				case 'base':
				case 'meta':
				case 'area':
				case 'basefont':
					// These should all be singly closed
					output.push(' />');
					break;
				case 'script':
					// Browsers handle script tags differently in how you get content,
					// but innerHTML always seems to work, so insert its content that way
					// Yes, it's bad to allow script tags in the editor code, but some people
					// seem to want to do it, so we need to at least return them right.
					// other plugins/filters can strip them.
					output.push('>', node.innerHTML, '</', lName, '>');
					break;
				default:
					output.push('>');
					if(node.hasChildNodes()){
						exports.getChildrenHtmlHelper(node, output);
					}
					output.push('</', lName, '>');
			}
			break;
		case 4: // cdata
		case 3: // text
			// FIXME:
			output.push(escape(node.nodeValue, true));
			break;
		case 8: // comment
			// FIXME:
			output.push('<!--', escape(node.nodeValue, true), '-->');
			break;
		default:
			output.push("<!-- Element not recognized - Type: ", node.nodeType, " Name: ", node.nodeName, "-->");
	}
};

exports.getChildrenHtml = function(/*DomNode*/ node: any){
	// summary:
	//		Returns the html content of a DomNode's children
	var output: any[] = [];
	exports.getChildrenHtmlHelper(node, output);
	return output.join("");
};

exports.getChildrenHtmlHelper = function(/*DomNode*/ dom: any, /*String[]*/ output: any){
	// summary:
	//		Pushes the html content of a DomNode's children into out[]

	if(!dom){
		return;
	}
	var nodes = dom["childNodes"] || dom;

	// IE issue.
	// If we have an actual node we can check parent relationships on for IE,
	// We should check, as IE sometimes builds invalid DOMS.  If no parent, we can't check
	// And should just process it and hope for the best.
	var checkParent = !has("ie") || nodes !== dom;

	var node, i = 0;
	while((node = nodes[i++])){
		// IE is broken.  DOMs are supposed to be a tree.  But in the case of malformed HTML, IE generates a graph
		// meaning one node ends up with multiple references (multiple parents).  This is totally wrong and invalid, but
		// such is what it is.  We have to keep track and check for this because otherwise the source output HTML will have dups.
		// No other browser generates a graph.  Leave it to IE to break a fundamental DOM rule.  So, we check the parent if we can
		// If we can't, nothing more we can do other than walk it.
		if(!checkParent || node.parentNode == dom){
			exports.getNodeHtmlHelper(node, output);
		}
	}
};

export default exports;
